const pointerType = 'activeVariants'
import {pointerUtils} from '@wix/document-manager-core'

const {getPointer} = pointerUtils

const createPointersMethods = () => ({
    activeVariants: {
        getActiveVariant: (compId: string) => getPointer(compId, pointerType)
    }
})

export {createPointersMethods}
